<template>
  <div class="notice delTeam" v-on:keyup.enter="ensure">
    <div class="noticeHead">
      {{params.noticeTitle}}
    </div>
    <div class="deleteNotice">
      <div class="deleteText">
        <p>确定删除“ <span>{{title}}</span> ”吗？</p>
        <p>删除小组后，该小组下的学生会回归到未分组</p>
      </div>
    </div>

    <div class="noticeClose" @click="closeNotice"></div>
    <div class="noticeBottom">
      <button class="sure" @click="ensure">确定</button>
      <button class="cancel" @click="abolish">取消</button>
    </div>
  </div>
</template>

<script>
import fetch from "./../../fetch";
export default {
  data() {
    return {
      isConfirm: false,
      title: "",
      studentsList: [],
      teamid: "",
      classId: "",
      isSuccess: false
    };
  },
  props: ["params"],
  created() {
    
    this.studentsList = this.params.groups;
    this.title = this.studentsList.title;
    this.teamid = this.studentsList.data[0].teamId;
    this.classId = this.studentsList.data[0].classId;
    console.log(this.studentsList);
  },
  methods: {
    closeNotice() {
      this.$emit("isConfirm", this.isConfirm);
    },

    // 取消选择
    abolish() {
      this.$emit("isConfirm", this.isConfirm);
    },

    // 确定
    ensure() {
      fetch.delTeam({ teamid: this.teamid }).then(res => {
        if (!res) {
          return false;
        }
        this.isSuccess = true
        console.log(JSON.parse(window.sessionStorage.getItem('studentsListData')))
        this.$toast("删除成功", "right");
        this.$emit("isConfirm",this.isSuccess);
      });
    },
  }
};
</script>


// WEBPACK FOOTER //
// delTeam.vue?431afc57